import Logo from "../Logo";

const Loading = () => {
    return (
        <div id="loading">
            <Logo />
        </div>
    );
}

export default Loading;